// Deterministic reference number for a Laporan Rincian Akun Bulanan, not a
// stored/atomic sequence — a statement is already uniquely identified by
// (business, year, month), so there's nothing to hand out atomically the
// way formatTransactionNumber's counter is. The business-id segment is what
// makes it distinct ACROSS studios: year+month alone would give every
// business's September statement the identical "STMT-202609". Shared by the
// statement list table and the downloaded PDF so the number a studio sees
// in-app always matches what's printed on the document.
export const formatStatementNumber = (
  businessId: string,
  year: number,
  month: number,
): string =>
  `STMT-${businessId.slice(0, 8).toUpperCase()}-${year}${String(month).padStart(2, "0")}`;
